import styled from 'styled-components'

export const Section = styled.section`
  padding: clamp(48px, 7vw, 90px) 0;
  background-color: #7aff6b;
`

export const Heading = styled.h2`
  max-width: 900px;
  margin: 0 auto 12px;
  font-size: clamp(26px, 4vw, 44px);
  color: #002107;
  line-height: 1.15;
  font-weight: 700;
  text-align: center;
`

export const Subheading = styled.p`
  max-width: 640px;
  margin: 0 auto clamp(28px, 4vw, 48px);
  font-size: clamp(16px, 1.6vw, 19px);
  font-weight: 600;
  color: #002c03;
  text-align: center;
`

export const Grid = styled.ul`
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
`

export const Card = styled.li`
  position: relative;
  background: #001d07;
  color: #fff;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 12px 28px rgba(0, 29, 7, 0.25);
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  /* desktop: 5 lado a lado */
  flex: 0 0 calc((100% - 80px) / 5);

  @media (hover: hover) {
    &:hover {
      transform: translateY(-6px);
      box-shadow: 0 18px 36px rgba(0, 29, 7, 0.35);
    }

    &:hover img {
      transform: scale(1.08);
    }
  }

  /* tablet: 3 + 2 centralizados */
  @media screen and (max-width: 1100px) {
    flex-basis: calc((100% - 40px) / 3);
  }

  /* celular: lista compacta, foto redonda ao lado do texto */
  @media screen and (max-width: 640px) {
    flex-basis: 100%;
    flex-direction: row;
    align-items: center;
    gap: 16px;
    padding: 16px;
    border-radius: 16px;
  }
`

export const Photo = styled.div`
  position: relative;
  aspect-ratio: 4 / 3;
  overflow: hidden;

  /* leve degradê para a foto "entrar" no card */
  &::after {
    content: '';
    position: absolute;
    inset: auto 0 0 0;
    height: 40%;
    background: linear-gradient(to bottom, transparent, #001d07);
    pointer-events: none;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform 0.5s ease;
  }

  @media screen and (max-width: 640px) {
    flex: 0 0 88px;
    width: 88px;
    height: 88px;
    aspect-ratio: 1 / 1;
    border-radius: 50%;
    border: 3px solid #a1ff71;

    &::after {
      display: none;
    }
  }
`

export const Numero = styled.span`
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 1;
  background: #a1ff71;
  color: #001d07;
  font-size: 13px;
  font-weight: 900;
  letter-spacing: 0.5px;
  padding: 4px 10px;
  border-radius: 999px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25);

  @media screen and (max-width: 640px) {
    display: none;
  }
`

export const Body = styled.div`
  padding: 4px 20px 24px;
  text-align: center;

  @media screen and (max-width: 640px) {
    padding: 0;
    text-align: left;
    min-width: 0;
  }
`

export const Name = styled.h3`
  font-size: clamp(19px, 1.8vw, 22px);
  font-weight: 900;
  color: #a1ff71;
  margin-bottom: 8px;

  @media screen and (max-width: 640px) {
    margin-bottom: 4px;
  }
`

export const Text = styled.p`
  font-size: 16px;
  line-height: 1.5;
  color: #d1d0d0;
`
